import {USER} from '../types';

export const userAction = ( data ) => async (dispatch) =>{

  dispatch({
      type: USER,
      payload: data
  });

}